(function () {
  var TEMPLATE_ID = 'w-video-modal-template';
  var root = null;
  var video = null;
  var closing = false;
  var hideTimer = null;
  var lastTrigger = null;
  var sourceCard = null;
  var raf = null;

  function template() {
    var tpl = document.getElementById(TEMPLATE_ID);
    return tpl && tpl.content ? tpl : null;
  }

  function onKeydown(event) {
    if (!root) return;
    if (event.key === 'Escape') return close();
    if (event.key === ' ' || event.key === 'k') {
      if (document.activeElement === root.querySelector('[data-vmodal-panel]')) {
        event.preventDefault();
        toggle();
      }
    }
  }

  function setState(state) {
    if (root) root.dataset.state = state;
  }

  function syncMuted() {
    if (root && video) root.dataset.muted = video.muted ? 'true' : 'false';
  }

  function tick() {
    raf = null;
    if (!root || !video) return;
    var fill = root.querySelector('[data-vmodal-progress-fill]');
    if (fill) {
      var ratio = isFinite(video.duration) && video.duration > 0 ? video.currentTime / video.duration : 0;
      fill.style.width = (ratio * 100).toFixed(2) + '%';
    }
    if (!video.paused && !video.ended) raf = requestAnimationFrame(tick);
  }

  function schedule() {
    if (raf === null) raf = requestAnimationFrame(tick);
  }

  function play() {
    if (!video) return;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        video.muted = true;
        syncMuted();
        var retry = video.play();
        if (retry && typeof retry.catch === 'function') retry.catch(function () { setState('idle'); });
      });
    }
  }

  function toggle() {
    if (!video) return;
    if (video.paused) play();
    else video.pause();
  }

  function seek(event) {
    if (!video || !isFinite(video.duration) || !video.duration) return;
    var bar = root.querySelector('[data-vmodal-progress]');
    var rect = bar.getBoundingClientRect();
    var ratio = (event.clientX - rect.left) / rect.width;
    video.currentTime = Math.max(0, Math.min(1, ratio)) * video.duration;
    schedule();
  }

  function close() {
    if (!root || closing) return;
    var node = root;
    closing = true;

    if (sourceCard && video) {
      var cardVideo = sourceCard.querySelector('video');
      if (cardVideo && isFinite(video.currentTime)) {
        try {
          cardVideo.currentTime = video.currentTime;
        } catch (e) {
          }
      }
    }
    if (video) video.pause();
    if (raf !== null) cancelAnimationFrame(raf);
    raf = null;

    node.classList.remove('is-open');
    document.body.classList.remove('w-scroll-lock');
    document.removeEventListener('keydown', onKeydown);

    var trigger = lastTrigger;
    var finalize = function () {
      clearTimeout(hideTimer);
      if (root === node) {
        node.remove();
        root = null;
        video = null;
      }
      closing = false;
    };
    var panel = node.querySelector('[data-vmodal-panel]');
    if (panel) {
      panel.addEventListener('transitionend', finalize, { once: true });
      hideTimer = setTimeout(finalize, 500);
    } else {
      finalize();
    }

    if (trigger && document.contains(trigger)) trigger.focus();
    lastTrigger = null;
    sourceCard = null;
  }

  function openFor(card, trigger) {
    var tpl = template();
    var cardVideo = card.querySelector('video');
    if (!tpl || !cardVideo) return false;

    if (root) close();

    root = tpl.content.firstElementChild.cloneNode(true);
    video = root.querySelector('[data-vmodal-video]');
    sourceCard = card;
    lastTrigger = trigger || card;

    var poster = cardVideo.getAttribute('poster');
    if (poster) video.setAttribute('poster', poster);
    Array.prototype.forEach.call(cardVideo.querySelectorAll('source'), function (src) {
      video.appendChild(src.cloneNode(true));
    });
    if (cardVideo.hasAttribute('loop')) video.setAttribute('loop', '');

    video.muted = false;
    video.load();
    if (cardVideo.currentTime > 0.1) {
      video.addEventListener('loadedmetadata', function () {
        try {
          video.currentTime = cardVideo.currentTime;
        } catch (e) {
          }
      }, { once: true });
    }
    cardVideo.pause();

    video.addEventListener('play', function () { setState('playing'); schedule(); });
    video.addEventListener('pause', function () { if (!video.ended) setState('paused'); });
    video.addEventListener('ended', function () { setState('idle'); tick(); });
    video.addEventListener('volumechange', syncMuted);
    video.addEventListener('timeupdate', schedule);

    document.body.appendChild(root);
    setState('idle');
    syncMuted();
    closing = false;

    void root.offsetHeight; // reflow, sinon aucune transition (cf. w-drawer)
    root.classList.add('is-open');
    document.body.classList.add('w-scroll-lock');
    document.addEventListener('keydown', onKeydown);

    root.addEventListener('click', function (event) {
      if (event.target === root) return close();
      if (event.target.closest('[data-vmodal-close]')) return close();
      if (event.target.closest('[data-vmodal-play]')) return toggle();
      if (event.target.closest('[data-vmodal-mute]')) {
        video.muted = !video.muted;
        syncMuted();
        return;
      }
      if (event.target.closest('[data-vmodal-progress]')) return seek(event);
      if (event.target === video) return toggle();
    });

    var panel = root.querySelector('[data-vmodal-panel]');
    if (panel) panel.focus();
    play();
    return true;
  }

  var IGNORE = '[data-play],[data-mute],[data-quick-add],a[href],select,input';

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-video-modal]');
    if (!card) return;
    if (event.target.closest(IGNORE)) return;
    if (!card.querySelector('video')) return;
    event.preventDefault();
    openFor(card, event.target.closest('button') || card);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var card = event.target.closest && event.target.closest('[data-video-modal][role="button"]');
    if (!card || !card.querySelector('video')) return;
    event.preventDefault();
    openFor(card, card);
  });

  document.addEventListener('cart:add', close);
})();
